/**
 * Card Reducer
 */
import { ActionTypes } from "containers/Card/store/ActionTypes";
import { CardAction } from "containers/Card/store/CardAction";
import { CardState } from "containers/Card/store/CardState";
import * as Handlers from "containers/Card/store/Handlers";
import { Reducer } from "redux";
import { getCardFormTranslations } from "root/shared/MultiLanguage";

const SELECT_CLASSES: string[] = ["select-pse"];

const initialState: CardState = {
  listBrandsLogosMerchant: [],
  commissionConfig: {
    totalAmount: 0,
    commissionMerchantName: "",
    parentMerchantName: "",
  },
  hasCommission: false,
  showCommissionsDetail: false,
  brand: "",
  cardType: "",
  bank: "",
  update: false,
  waitingViewEnabled: undefined,
  showVoucher: undefined,
  amountPerMonth: "",
  isValid: false,
  isDeferred: false,
  cardHolder: {
    value: "",
    classContainer: "inputContainer name-input section",
    dirty: false,
    valid: false,
    inputPattern: /^[ A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    classes: ["input", "input-name"],
    rules: {
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "cardHolder",
      type: "text",
      name: "name",
    },
  },
  cardNumber: {
    value: "",
    classContainer: "inputContainer cardNumber-input section",
    dirty: false,
    valid: false,
    inputPattern: /^\d*$/,
    presentationPattern: /.{1,4}/g,
    separator: " ",
    classes: ["input", "input-cardNumber"],
    rules: {
      required: true,
      isCardNumber: true,
      maxLength: 18,
    },
    attributes: {
      id: "cardNumber",
      type: "text",
      name: "number",
    },
  },
  expDate: {
    value: "",
    classContainer: "inputContainer cardDate-input left",
    dirty: false,
    valid: false,
    inputPattern: /^\d*$/,
    presentationPattern: /.{1,2}/g,
    separator: "/",
    classes: ["input", "input-cardDate"],
    rules: {
      required: true,
      isDate: true,
      maxLength: 4,
    },

    attributes: {
      id: "expDate",
      type: "text",
      name: "expDate",
    },
  },
  cardCVC: {
    value: "",
    classContainer: "inputContainer cardCvc-input right",
    dirty: false,
    valid: false,
    inputPattern: /^\d*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    classes: ["input", "input-cardCvc"],
    rules: {
      required: true,
      minLength: 3,
      maxLength: 4,
    },
    attributes: {
      id: "cardCVC",
      type: "password",
      name: "cvv",
    },
  },
  email: {
    value: "",
    classContainer: "inputContainer email-input",
    dirty: false,
    valid: true,
    inputPattern: new RegExp(""),
    presentationPattern: /.{1,}/g,
    separator: "",
    classes: ["input", "input-email"],
    rules: {
      required: false,
      isEmail: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
      maxLength: 100,
    },
    attributes: {
      id: "email",
      type: "text",
      name: "email",
    },
  },
  deferredOptionsComponent: {
    id: "deferredOptionsComponent",
    valid: false,
    deferredTypeSelect: {
      id: "deferredTypeSelect",
      value: "",
      inputItems: [],
      classes: SELECT_CLASSES,
    },
    monthsSelect: {
      id: "monthsSelect",
      value: "",
      inputItems: [],
      classes: SELECT_CLASSES,
    },
    monthsOfGraceSelect: {
      id: "monthsOfGraceSelect",
      value: "",
      inputItems: [],
      classes: SELECT_CLASSES,
    },
    optionsFetch: {},
  },
  translation: getCardFormTranslations(),
};

/* tslint:disable:cyclomatic-complexity */
const CardReducer: Reducer<CardState, CardAction> = (
  // istanbul ignore next
  state: CardState = initialState,
  action: CardAction
): CardState => {
  // TODO hard branch ensurance
  switch (action.type) {
    case ActionTypes.UPDATE_CARD_INPUT:
      return Handlers.UpdateCardInput(action, state);
    case ActionTypes.SET_CARD_INPUT_DIRTY:
      return Handlers.UpdateCardInputDirty(action, state);
    case ActionTypes.SWITCH_CARD_VALIDITY:
      return Handlers.UpdateCardValidation(state);
    case ActionTypes.SWITCH_IS_DEFERRED:
      return Handlers.UpdateDeferredState(state);
    case ActionTypes.SET_CARD_TOKEN:
      return Handlers.UpdateCardToken(state, action);
    case ActionTypes.SET_DEFERRED_OPTIONS:
      return Handlers.updateDeferredOptions(state, action);
    case ActionTypes.SET_COMMISSION_CONFIG:
      return Handlers.SetCommissionConfig(state, action);
    case ActionTypes.SET_COMMISSION_FLAG:
      return Handlers.SetCommissionFlag(state, action);
    case ActionTypes.SET_SHOW_COMMISSION_DETAILS:
      return Handlers.SetShowCommissionsDetail(state, action);
    case ActionTypes.UPDATE_DEFERRED_TYPE_SELECT:
      return Handlers.UpdateDeferredTypeSelect(action, state);
    case ActionTypes.UPDATE_DEFERRED_SELECT_VALUE:
      return Handlers.UpdateDeferredValue(action, state);
    case ActionTypes.SWITCH_DEFERRED_OPTIONS_VALIDITY:
      return Handlers.UpdateDeferredOptionsValidation(state);
    case ActionTypes.RESET_DEFERRED_OPTIONS:
      return Handlers.ResetDeferredOptions(state);
    case ActionTypes.ENABLE_OTP_WAIT_VIEW:
      return Handlers.EnableOptView(state, action);
    case ActionTypes.UPDATE_OTP_STATE:
      return Handlers.UpdateOtpState(state, action);
    case ActionTypes.UPDATE_OTP_FAIL_MESSAGE:
      return Handlers.UpdateOtpFailMessage(state, action);
    case ActionTypes.UPDATE_SECURE_SERVICE_ID:
      return Handlers.UpdateSecureServiceId(state, action);
    case ActionTypes.UPDATE_SECURE_SERVICE_NAME:
      return Handlers.UpdateOtpType(state, action);
    case ActionTypes.UPDATE_OTP_VALUE:
      return Handlers.UpdateOtpValue(state, action);
    case ActionTypes.DISABLE_OTP_WAIT_VIEW:
      return Handlers.DisableOtpView(state);
    case ActionTypes.ENABLE_OTP_ERROR:
      return Handlers.EnableOtpError(state);
    // istanbul ignore next
    case ActionTypes.DISABLE_OTP_ERROR:
      // istanbul ignore next
      return Handlers.DisableOtpError(state);
    case ActionTypes.UPDATE_STATE:
      return Handlers.Refresh(state);
    case ActionTypes.DELETE_OTP_FAIL_MESSAGE:
      return Handlers.deleteOtpFailMessage(state);
    case ActionTypes.UPDATE_NESTED_MESSAGE:
      return Handlers.UpdateNestedMessage(state, action);
    case ActionTypes.UPDATE_NESTED_ERROR_CODE:
      return Handlers.UpdateNestedErrorCode(state, action);
    case ActionTypes.UPDATE_CARD_BRAND:
      return Handlers.UpdateBrandCard(state, action);
    case ActionTypes.UPDATE_BRANDS_LOGOS_LIST:
      return Handlers.UpdateBrandsLogos(state, action);
    case ActionTypes.RESET_CARD_STATE:
      return initialState;
    case ActionTypes.ENABLE_VOUCHER_VIEW:
      return Handlers.EnableVoucherView(state);
    case ActionTypes.DISABLE_VOUCHER_VIEW:
      return Handlers.DisableVoucherView(state);
    case ActionTypes.UPDATE_AMOUNT_PER_MONTH:
      return Handlers.UpdateAmountPerMonth(state, action);
    case ActionTypes.ENABLE_TOKEN_WITHOUT_CVV:
      return Handlers.EnableTokenWithoutCvv(state);
    case ActionTypes.UPDATE_EMAIL_VALIDITY:
      return Handlers.UpdateEmailValidity(state, action);
    case ActionTypes.EXCEEDED_RETRIES:
      return Handlers.SetExceededRetries(state);
    default:
      return state;
  }
};

export { CardReducer };



// WEBPACK FOOTER //
// ./src/containers/Card/store/Reducer.tsx